import { Component, ElementRef, Input, OnDestroy, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
 
//declare var FLVJSPlayback
 
declare var flvjs;

//

@Component({
  selector: 'restream-player',
 templateUrl: './restream-player.component.html',
  
  styleUrls: [
    './restream-player.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
}) 
export class RestreamPlayerComponent implements OnInit, OnDestroy {
  @ViewChild('target', {static: true}) target: ElementRef;
    
  @Input() sources: {src:string, type}[];
  @Input() hasSignal: boolean = false;
 

  // @HostListener('document:visibilitychange') visibilitychange(){this.onDocumentVisibilityChange('hidden')};
 //  @HostListener('document:msvisibilitychange') msvisibilitychange(){this.onDocumentVisibilityChange('msHidden')};
  // @HostListener('document:webkitvisibilitychange') webkitvisibilitychange(){this.onDocumentVisibilityChange('webkitHidden')};

  docVisChangeEventName:string = '';
  docVisChangeFunc: any = null;

  player: any;
  covered: boolean  = true
   src:string

  muted:boolean = true

  constructor(
    private elementRef: ElementRef,
  ) { }

  ngOnInit() {

	let hidden, visibilityChange;
	// @ts-ignore
	if (typeof document?.hidden !== "undefined") { 
	  hidden = "hidden";
	  visibilityChange = "visibilitychange";
         // @ts-ignore
	} else if (typeof document?.msHidden !== "undefined") {
	  hidden = "msHidden";
	  visibilityChange = "msvisibilitychange";
         
         // @ts-ignore
	} else if (typeof document?.webkitHidden !== "undefined") {
	  hidden = "webkitHidden";
	  visibilityChange = "webkitvisibilitychange";
	}

	if(visibilityChange){
	  this.docVisChangeEventName = visibilityChange;
	  this.docVisChangeFunc = this.onDocumentVisibilityChange.bind(this, hidden)
	      document.addEventListener(this.docVisChangeEventName,  this.docVisChangeFunc);
	}

  }


  onDocumentVisibilityChange(prop){
	
	if(!document[prop]){
	   this.initPlayer((this.src || this.sources[0].src))
	}

  }

  start(){
    try{  
     	
	this.initPlayer(this.sources[0].src)
	
	//this.setSource(this.sources[0].src)
 
    }catch(err){
	//console.log(err)
    }
  }
  stop(){
     try{  
     
  	this.initPlayer('')
  	 
     }catch(err){
     //  console.log(err)
    }
  }

  setSource(source){
    this.src =  source.src
    this.covered = false;
    this.initPlayer(this.src)
    
  }

   
 
    async initPlayer(src){
 
	  try{  
	    if(this.player){
		this.player.unload();
	        this.player.detachMediaElement();
	   	this.player.destroy()
		this.player = null
	    }

		
	    if (flvjs.isSupported()  && src) {

		//this.muted = true

		this.player = flvjs.createPlayer({
		    type: 'flv',
		    isLive:true,
		    url: src,
		    enableStashBuffer:false,
	            cors: true,
                    withCredentials: false,
		    hasAudio: true,
		    hasVideo: true
		});
 		     
		this.player.attachMediaElement(this.target.nativeElement);
 
		this.player.load();
		await this.player.play();
	    }

	  }catch(err){

          }
  }


  ngOnDestroy() {
    if(this.player){
   	 this.player.destroy()

	}

	if( this.docVisChangeFunc){
 		 document.removeEventListener(this.docVisChangeEventName,  this.docVisChangeFunc);

	}
  }
}
